import { render } from "./ModalFaleConosco.vue?vue&type=template&id=f5118d6a&scoped=true"
import script from "./ModalFaleConosco.vue?vue&type=script&lang=js"
export * from "./ModalFaleConosco.vue?vue&type=script&lang=js"

import "./ModalFaleConosco.vue?vue&type=style&index=0&id=f5118d6a&scoped=true&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5118d6a"]])

export default __exports__